module.exports = __webpack_public_path__ + "static/media/on-trac.e3ecb591.svg";